import { useState, useEffect } from "react";
import { Row, Col, Card, Container } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { getCompany } from "../../store/actions";
import { SkeletonTheme } from "react-loading-skeleton";
import { updateProfileSwitch, getChannelById } from "../../store/actions";
import TableContainer from "../../components/Common/TableContainer";
import BreadCrumb from "../../components/Common/BreadCrumb";
import { useHistory } from "react-router-dom";
import useAuthUser from "../../components/Hooks/useAuthUser";
import { Button } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { translateApiError } from "../../helpers/translateApiError";

const AllAccounts = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { isSuperAdmin } = useAuthUser();

  if (!isSuperAdmin) {
    history.push("/dashboard");
  }

  const {
    company,
    isCompanyLoading,
    companyError,
    pageCount,
    hasPreviousPage,
    hasNextPage,
  } = useSelector((state) => ({
    company: state.Company.company,
    isCompanyLoading: state.Company.isCompanyLoading,
    companyError: state.Company.companyError,
    pageCount: state.Company.pageCount,
    hasPreviousPage: state.Company.hasPreviousPage,
    hasNextPage: state.Company.hasNextPage,
  }));

  const [pageParams, setPageParamsState] = useState({
    rowsPerPage: 5,
    currentPage: 1,
  });

  // Wrapper to handle partial updates
  const setPageParams = (params) => {
    setPageParamsState((prev) => ({ ...prev, ...params }));
  };

  // query parameters for SEARCH TERM, DATE, STATUS,
  const [filterParams, setFilterParams] = useState({
    search: "",
    status: "",
  });

  const clientListColumns = [
    {
      Header: t("account.allAccounts.portalId"),
      accessor: "portalId",
      filterable: false,
    },
    {
      Header: t("account.allAccounts.tenantName"),
      accessor: "TenantName",
      filterable: false,
    },
    {
      Header: t("account.allAccounts.code"),
      accessor: "channelToken",
      Cell: (cell) => {
        return cell.row.original?.channel?.token;
      },
      filterable: false,
    },
    {
      Header: (
        <div style={{ textAlign: "center" }}>
          {t("account.allAccounts.switchUser")}
        </div>
      ),
      accessor: "switchUser",
      Cell: (cell) => {
        return (
          <div className="d-flex justify-content-center">
            <Button
              type="button"
              className="btn btn-warning text-primary"
              onClick={() => handleSwitchUser(cell.row.original)}
            >
              {t("account.allAccounts.switch")}
            </Button>
          </div>
        );
      },
    },
  ];

  const handleSwitchUser = (company) => {
    dispatch(
      updateProfileSwitch({
        isUserSwitch: true,
        email: company?.emailAddress,
        company: company?.tenantName,
      })
    );
    dispatch(getChannelById(company?.channelId));

    // Set ConnectionStatus to Session Storage
    sessionStorage.setItem("connectionStatus", JSON.stringify(company?.state));

    history.push("/dashboard");
  };

  useEffect(() => {
    dispatch(getCompany({ ...pageParams, ...filterParams }));
  }, [dispatch, pageParams, filterParams]);

  return (
    <SkeletonTheme baseColor="#F0F4F6" highlightColor="#e9ebec">
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={t("account.allAccounts.title")}
            hideCrumbs={true}
          />

          <>
            {companyError ? (
              <>
                {toast(`${translateApiError(companyError)}`, {
                  position: "top-right",
                  hideProgressBar: false,
                  type: "error",
                  className: "",
                  progress: undefined,
                  toastId: "",
                })}
                <ToastContainer autoClose={2000} limit={1} />
              </>
            ) : null}

            <Row>
              <Col lg={12}>
                <Card>
                  <div className="bg-white rounded-1 py-4 px-4 d-flex justify-content-end border-1 border-gray-100">
                    <div className="search-box d-inline-block">
                      <input
                        onChange={(e) => {
                          setFilterParams((prevState) => ({
                            ...prevState,
                            search: e.target.value,
                          }));
                        }}
                        id="search-bar-0"
                        type="text"
                        className="form-control search /"
                        placeholder={t("account.allAccounts.searchPlaceholder")}
                        value={filterParams.search || ""}
                      />
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                  <div className="pb-5">
                    <div className="px-3 pt-0">
                      <TableContainer
                        columns={clientListColumns}
                        data={company || []}
                        loading={isCompanyLoading}
                        pageCount={pageCount}
                        hasPreviousPage={hasPreviousPage}
                        hasNextPage={hasNextPage}
                        pageParams={pageParams}
                        setPageParams={setPageParams}
                        // filterParams={filterParams}
                        // setFilterParams={setFilterParams}
                        disableRowModal={true}
                        datePicker={false} // disable datepicker
                        // selectFilterOptions={accountStatusOptions}
                        // isGlobalFilter={true}
                        isGlobalSearch={true}
                        customPageSize={10}
                        className="custom-header-css"
                        theadClass="text-muted"
                      />
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </>
        </Container>
      </div>
    </SkeletonTheme>
  );
};

export default AllAccounts;
